import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
class Wizard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeIndex: props.activeIndex || 0,
    }

    this.renderSteps = this.renderSteps.bind(this)
    this.showNextStep = this.showNextStep.bind(this)
    this.showPreviousStep = this.showPreviousStep.bind(this)
  }

  componentWillReceiveProps({ activeIndex }) {
    if (activeIndex !== null && activeIndex !== undefined) {
      this.setState({
        activeIndex,
      })
    }
  }

  showNextStep() {
    const { children } = this.props
    const { activeIndex } = this.state
    const nextIndex = activeIndex + 1
    const nextChild = children[nextIndex]

    if (!nextChild) return

    this.setState({ activeIndex: nextIndex })
  }

  showPreviousStep() {
    const { children } = this.props
    const { activeIndex } = this.state
    const prevIndex = activeIndex - 1
    const prevChild = children[prevIndex]

    if (!prevChild) return

    this.setState({ activeIndex: prevIndex })
  }

  renderSteps() {
    const { children } = this.props
    const { activeIndex } = this.state

    // no content
    if (!children) return []
    // just one child element
    if (!children.length) return children

    // multiple child elements
    const filteredChildren = React.Children.toArray(children).filter((child) => {
      const { props: { render } } = child
      return render
    })
    return filteredChildren.map((child, index) => {
      const { props: { active, onNext, onPrevious } } = child
      const props = Object.assign({}, child.props, {
        active: active === undefined ? active : activeIndex === index,
        onNext: !onNext ? this.showNextStep : onNext,
        onPrevious: !onPrevious ? this.showPreviousStep : onPrevious,
      })
      return React.cloneElement(child, props)
    })
  }

  render() {
    const { customClass } = this.props

    return (
      <div className={`wizard ${customClass}`}>
        <PerfectScrollbar options={{ suppressScrollX: true }} className={'forcePerfectScrollbarRight'}>
          { this.renderSteps() }
        </PerfectScrollbar>
      </div>
    )
  }
}

Wizard.defaultProps = {
  customClass: '',
}

export default Wizard
